import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-66" data-mp="3jzx4q0zo8apx">
      {eyebrow && <p className={`text-xs sm:text-sm font-bold uppercase tracking-[0.18em] ${dark ? "text-gold" : "text-brand"}`} data-id="element-67" data-mp="3k29liatp0f1e">{eyebrow}</p>}
      <h2 className={`mt-3 font-serif text-[32px] leading-[1.12] sm:text-5xl font-bold text-balance ${dark ? "text-white" : "text-ink"}`} data-id="element-68" data-mp="gjzr1i2awkmu">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/80" : "text-ink/70"}`} data-id="element-69" data-mp="6sveep03lbv6">{subtitle}</p>}
    </div>;
}